<template>
  <div class="provider-page">
    <provider-sidebar></provider-sidebar>
    <provider-header></provider-header>
    <!-- Page Wrapper -->
    <div class="page-wrapper">
      <div class="content container-fluid">
        <div class="row">
          <div class="d-flex justify-content-between align-items-center flex-wrap mb-4">
            <h5>Profile Verification</h5>
          </div>
        </div>
        <!-- Security Settings -->
        <div class="row profile-verification">
          <div class="col-xl-4 col-md-4 d-flex mb-3">
            <div class="card flex-fill">
              <div class="card-body">
                <div class="verification-body">
                  <div class="icon">
                    <span
                      class="rounded-circle d-flex align-items-center justify-content-center"
                      ><i class="ti ti-phone text-dark"></i
                    ></span>
                  </div>
                  <div class="verification-content">
                    <h6 class="fs-16 mb-1">Phone Number Verification</h6>
                    <p class="fs-14 text-gray mb-0">
                      Authentication for Login, OTP, Settings, transfers
                    </p>
                  </div>
                </div>
                <div class="verification-footer">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <div class="d-flex">
                        <span class="badge badge-soft-danger d-flex align-items-center"
                          ><i class="ti ti-point-filled"></i>Not Verified</span
                        >
                      </div>
                    </div>
                    <div class="col-md-6 d-flex justify-content-end">
                      <div class="d-flex align-items-center">
                        <a href="javascript:void(0);" class="btn btn-dark btn-sm me-2"
                          >Verify</a
                        >
                        <a href="javascript:void(0);"
                          ><span><i class="ti ti-trash"></i></span
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-4 d-flex mb-3">
            <div class="card flex-fill">
              <div class="card-body">
                <div class="verification-body">
                  <div class="icon">
                    <span
                      class="rounded-circle d-flex align-items-center justify-content-center"
                      ><i class="ti ti-mail text-dark"></i
                    ></span>
                  </div>
                  <div class="verification-content">
                    <h6 class="fs-16 mb-1">Email Address Verification</h6>
                    <p class="fs-14 text-gray mb-0">
                      For account Login & Retrieve of your Account
                    </p>
                  </div>
                </div>
                <div class="verification-footer">
                  <div class="row align-items-center">
                    <div class="col-md-6">
                      <div class="d-flex">
                        <span class="badge badge-soft-danger d-flex align-items-center"
                          ><i class="ti ti-point-filled"></i>Not Verified</span
                        >
                      </div>
                    </div>
                    <div class="col-md-6 d-flex justify-content-end">
                      <div class="d-flex align-items-center">
                        <a href="javascript:void(0);" class="btn btn-dark btn-sm me-2"
                          >Verify</a
                        >
                        <a href="javascript:void(0);"
                          ><span><i class="ti ti-trash"></i></span
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-4 col-md-4 d-flex mb-3">
            <div class="card flex-fill">
              <div class="card-body">
                <div class="verification-body">
                  <div class="icon">
                    <span
                      class="rounded-circle d-flex align-items-center justify-content-center"
                      ><i class="ti ti-file text-dark"></i
                    ></span>
                  </div>
                  <div class="verification-content">
                    <h6 class="fs-16 mb-1">Documentation Verification</h6>
                    <p class="fs-14 text-gray mb-0">
                      You will not able to place order until the real name is confirmed
                    </p>
                  </div>
                </div>
                <div class="verification-footer">
                  <div class="row align-items-center">
                    <div class="col-md-5">
                      <div class="d-flex">
                        <span class="badge badge-soft-danger d-flex align-items-center"
                          ><i class="ti ti-point-filled"></i>Not Verified</span
                        >
                      </div>
                    </div>
                    <div class="col-md-7 d-flex justify-content-end">
                      <div class="d-flex align-items-center">
                        <a
                          href="javascript:void(0);"
                          class="btn btn-dark btn-sm me-2"
                          data-bs-toggle="modal"
                          data-bs-target="#upload-document"
                          >Upload Document</a
                        >
                        <a href="javascript:void(0);"
                          ><span><i class="ti ti-trash"></i></span
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- /Security Settings -->
      </div>
    </div>
    <!-- /Page Wrapper -->
    <provider-verification-modal></provider-verification-modal>
  </div>
</template>
